export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '变更类型',
            prop: 'updateType',
            type: 'select',
            optionsKey: 'CUSTOMER_UPDATE_TYPE'
        },
        {
            label: '操作类型',
            prop: 'operateTypeName'
        },
        {
            label: '关联变更单号',
            prop: 'customerChangeCode'
        },
        {
            label: '变更项目',
            prop: 'updateFieldCode'
        },
        {
            label: '变更项目名称',
            prop: 'updateFieldName'
        },
        {
            label: '变更前编码',
            prop: 'oldValue',
            type: 'slot',
            width: 180
        },
        {
            label: '变更前名称',
            prop: 'oldValueName',
            type: 'slot',
            width: 180
        },
        {
            label: '变更后编码',
            prop: 'newValue',
            type: 'slot',
            width: 180
        },
        {
            label: '变更后名称',
            prop: 'newValueName',
            type: 'slot',
            width: 180
        },
        {
            label: '修改人',
            prop: 'updateUserName'
        },
        {
            label: '修改时间',
            prop: 'updateTime'
        }
    ]
};
